import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LOCALES, type Locale } from '@scoreboard/shared';
import en from '@scoreboard/shared/locales/en.json';
import fr from '@scoreboard/shared/locales/fr.json';

// i18next sur les fichiers partagés `packages/shared/locales` (arbitrage doc 00 §4.26) :
// un seul jeu FR/EN pour webapp, admin et mobile. Zéro chaîne en dur (doc 00 §6.3.2).

export const LOCALE_STORAGE_KEY = 'scorofun.locale';

export function detectLocale(): Locale {
  const stored = safeRead(LOCALE_STORAGE_KEY);
  if (stored !== null && (LOCALES as readonly string[]).includes(stored)) {
    return stored as Locale;
  }
  const navigatorLang = globalThis.navigator?.language ?? 'fr';
  return navigatorLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
}

export function setLocale(locale: Locale): void {
  safeWrite(LOCALE_STORAGE_KEY, locale);
  void i18next.changeLanguage(locale);
  globalThis.document?.documentElement.setAttribute('lang', locale);
}

export function initI18n(locale: Locale = detectLocale()): typeof i18next {
  if (!i18next.isInitialized) {
    void i18next.use(initReactI18next).init({
      resources: { fr: { translation: fr }, en: { translation: en } },
      lng: locale,
      fallbackLng: 'en',
      interpolation: { escapeValue: false }, // React échappe déjà
      returnNull: false,
    });
  }
  globalThis.document?.documentElement.setAttribute('lang', locale);
  return i18next;
}

function safeRead(key: string): string | null {
  try {
    return globalThis.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeWrite(key: string, value: string): void {
  try {
    globalThis.localStorage.setItem(key, value);
  } catch {
    /* mode privé : la préférence ne survit pas à la session, sans conséquence */
  }
}

export { safeRead, safeWrite };
export default i18next;
